import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=4008e7c4&"
import script from "./Promotion.vue?vue&type=script&lang=ts&"
export * from "./Promotion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports